import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import Check from "@material-ui/icons/Check";
import Cancel from "@material-ui/icons/Cancel";
import { useState } from "react";

const ActionsCell = (props) => {
  const { table, row, rowState } = props;
  // table state
  const { setEditRowIndex } = table.options.state;
  // rowState
  const {
    isMutationLoading,
    isMutationError,
    disableSubmit,
    setActiveRowData,
    setNotFilledMandatoryFields,
    activeRowData,
    updateRowFunc,
    mutationReset,
    setNoProperInputFields,
  } = rowState;

  // render conditions
  const currentIndex = row.id;

  // confirmation popup

  const [isConfirmationPopupOpen, setIsConfirmationPopupOpen] = useState({
    open: false,
    for: "",
  });

  // buttons
  return (
    <>
      <Box width={"100%"}>
        {isMutationLoading ? (
          <Box display={"flex"} justifyContent={"center"}>
            <CircularProgress size={20} />
          </Box>
        ) : (
          <Box display={"flex"} justifyContent={"space-between"}>
            <IconButton
              className="action-button"
              onClick={() => {
                if (!disableSubmit) {
                  updateRowFunc(table);
                }
              }}
            >
              <Check color="secondary" />
            </IconButton>
            <IconButton
              className="action-button"
              onClick={() => {
                if (Object.keys(activeRowData).length > 0) {
                  setIsConfirmationPopupOpen({ open: true, for: "existing" });
                } else {
                  setEditRowIndex(null);
                  setNotFilledMandatoryFields([]);
                  mutationReset();
                  setActiveRowData({});
                }
              }}
            >
              <Cancel color="secondary" />
            </IconButton>
          </Box>
        )}
      </Box>
      {isConfirmationPopupOpen.open ? (
        <Dialog open={isConfirmationPopupOpen.open} maxWidth="xs">
          <DialogContent>
            Are you sure , you want to discard the changes you made?
          </DialogContent>
          <DialogActions>
            <Button
              style={{ textTransform: "none" }}
              onClick={() => {
                if (isConfirmationPopupOpen.for === "existing") {
                  setEditRowIndex(null);
                }
                if (isConfirmationPopupOpen.for === "new") {
                  setEditRowIndex(currentIndex);
                }
                setActiveRowData({});
                setIsConfirmationPopupOpen({ open: false, for: "" });
                setNotFilledMandatoryFields([]);
              }}
            >
              Discard
            </Button>
            <Button
              style={{ textTransform: "none" }}
              onClick={() => {
                setIsConfirmationPopupOpen({ open: false, for: "" });
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default ActionsCell;
